var waiterDom = require('./waiter.html');

class FintectureHandler {
  constructor(target, promoter_slug, reservation_id) {
    this.target = target;
    this.promoter_slug = promoter_slug;
    this.reservation_id = reservation_id;
  }

  startWaiting() {
    this.target.append($( waiterDom ));
    // this.refreshStatus();
    this.refreshStatusInterval = setInterval(() => { this.refreshStatus() }, 1000);
  }

  refreshStatus() {
    $.ajax({
      method: 'GET',
      url: `/api/${this.promoter_slug}/reservations/${this.reservation_id}`
    })
    .done((data) => {
      console.log(data);
      var resaData = data.reservation;
      if (resaData['status'] === 'cancelled') {
        window.location = resaData['reservation_url'];
      } else if (!_.isNil(resaData['fintecture_redirect_url'])) {
        window.location = resaData['fintecture_redirect_url'];
      }
    })
    .fail((e) => {
      console.log('error', e);
    });
  }
}

var buildFintectureHandler = function (options) {
  var settings = $.extend({
  }, options );
  var builder = new FintectureHandler($(this), $(this).data('promoter-slug'), $(this).data('reservation-id'));
  builder.startWaiting();

  return builder;
};

export default buildFintectureHandler;
